export default "__VITE_ASSET__BS9gDgVS__"